export default (function (_ref) {
  var width = _ref.width,
      height = _ref.height;
  return width > height ? 'landscape' : width === height ? 'square' : 'portrait';
});